import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-scrutiny-view',
  templateUrl: './scrutiny-view.component.html',
  styleUrls: ['./scrutiny-view.component.css']
})
export class ScrutinyViewComponent implements OnInit {
  title = "Scrutiny View"
  Property_Type: any;
  RES_Id: any;
  CA_Id: any;
  s: any;
  PND: any;
  PD_Id: any;
  DSWOID_NO_Id: any;
  PD: any;
  AFD: any = {};
  data: any;
  NO_Id: any;
  APP_Id: any;
  ScrutinyObj: any = {};

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      //  this.mode = params['mode'];
      this.APP_Id = params['APP_Id'];
      this.DSWOID_NO_Id = params['S_NotificationID'];
      this.PD_Id = params['S_ProjectID'];
      this.CA_Id = params['S_CA_Id_FK'];
      this.RES_Id = params['S_Reservation_Id_FK'];
      this.Property_Type = params['S_Property_Type'];
    });

    if (this.APP_Id != null)
      this.GetApplicationScrutinyFormDetails(this.APP_Id);
    // this.GetApplicationFormDetails(this.APP_Id);
    this.GETProjectNotificationDetails(this.DSWOID_NO_Id, this.PD_Id);
  }

  GetApplicationScrutinyFormDetails(APP_Id) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApplicationScrutinyFormDetails(APP_Id);
    this.data.subscribe(
      (response: any) => {
        this.AFD = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GETProjectNotificationDetails(DSWOID_NO_Id, PD_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getProjectNotificationDetails(DSWOID_NO_Id, PD_Id);
    this.data.subscribe(
      (response: any) => {
        this.PND = response;
        if (this.PND.DSWOId_NO_Date != null)
          this.PND.DSWOId_NO_Date = ((this.PND.DSWOId_NO_Date).split('T'))[0];
        if (this.PND.DSWOId_NO_LastDate != null)
          this.PND.DSWOId_NO_LastDate = ((this.PND.DSWOId_NO_LastDate).split('T'))[0];
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  Eligible(APP_Id, IsEligible: any, Note, APP_No) {
    document.getElementById('loader-spinner').style.display = "block";
    IsEligible = 'Y';
    Note = "NULL";
    this.ScrutinyObj.IsEligible = IsEligible;
    this.ScrutinyObj.APP_Id = APP_Id;
    this.ScrutinyObj.Note = Note;
    this.data = this.userService.updateApplicationScrutiny(this.ScrutinyObj);
    this.data.subscribe(
      (response) => {
        // this.APP_Id=response;
        // console.log(Application);
        //  Application.reset();
        //Application.resetForm();
        // this.formInvalid = false;
        swal('Success!', 'Application No.: ' + APP_No + ' is made eligible for allotment.', 'success');
        this.router.navigate(['home/scrutiny/scrutinized/', this.DSWOID_NO_Id, this.PD_Id, this.CA_Id, this.RES_Id, this.Property_Type]);
        // swal1('Success!', 'Application APP-No' +response +'details has been saved successfully.', 'success','route');
        document.getElementById('loader-spinner').style.display = "none";
        
        //this.router.navigate(['home/applicant/applicantview/',this.APP_Id]);
        // window.location.href(='home/applicantview/';
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  NotEligible(APP_Id, IsEligible: any, Note, APP_No) {
    
    document.getElementById('loader-spinner').style.display = "block";
    IsEligible = 'N';
    this.ScrutinyObj.IsEligible = IsEligible;
    this.ScrutinyObj.APP_Id = APP_Id;
    this.ScrutinyObj.Note = Note;
    this.data = this.userService.updateApplicationScrutiny(this.ScrutinyObj);
    this.data.subscribe(
      (response) => {
        //this.APP_Id=response;
        // console.log(Application);
        // Application.reset();
        //Application.resetForm();
        // this.formInvalid = false;
        swal('Success!', 'Application No. ' + APP_No + ' is not eligible for allotment.', 'success');
        this.router.navigate(['home/scrutiny/scrutinized/', this.DSWOID_NO_Id, this.PD_Id, this.CA_Id, this.RES_Id, this.Property_Type]);
        document.getElementById('loader-spinner').style.display = "none";
        //this.router.navigate(['home/applicant/applicantview/',this.APP_Id]);
        // window.location.href(='home/applicantview/';
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/scrutiny-view/scrutiny-view.component.ts